import { useCachedApiCall } from '@hooks/apiCall';
import { orgLicenseCache, organizationsCache } from './organizationStore';

/*
 * Thin cache-backed bindings so hooks and features don't hand-roll
 * param arrays. See docs/api-caching.md §8 for the hook contract.
 */

/** Cache-backed organizations of the signed-in user. */
export const useOrganizationsEntry = () =>
    useCachedApiCall(organizationsCache, []);

/** Cache-backed license of an organization. */
export const useOrgLicenseEntry = (orgId?: string) =>
    useCachedApiCall(orgLicenseCache, [orgId], [orgId]);
